import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  LayoutDashboard,
  ImageIcon,
  Type,
  MousePointer,
  Save,
  Loader2
} from 'lucide-react';

import s from './WhyHostFormBlock1.css';
import Image from './Image';
import messages from '../../../../locale/messages';
import submit from './submit';
import validate from './validate';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';

class WhyHostFormBlock1 extends Component {
  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, hostBannerloader, hostImageLoader, bannerImage, hostImage, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['hostBannerTitle1', 'hostBannerContent1', 'hostBannerContent2', 'buttonLabel', 'buttonLabel2'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={s.pageContainer}>
        {/* Page Header */}
        <div className={s.pageHeader}>
          <h1 className={s.pageTitle}>
            <div className={s.pageTitleIcon}>
              <LayoutDashboard size={24} />
            </div>
            <FormattedMessage {...messages.WhyBecomeOwnerBlock1} />
          </h1>
          <p className={s.pageSubtitle}>
            Configure the hero section of the Why Become Owner page
          </p>
        </div>

        <form onSubmit={handleSubmit((values) => {
          const payload = { ...values, ...formValues };
          return submit(payload, dispatch);
        })}>
          {hiddenFields}
          {error && <div className="alert alert-danger">{formatMessage(error)}</div>}

          {/* Images Grid */}
          <div className={s.imagesGrid}>
            <div className={s.imageCard}>
              <div className={s.imageCardHeader}>
                <div className={s.imageCardHeaderIcon}>
                  <ImageIcon size={16} />
                </div>
                <h3 className={s.imageCardTitle}>
                  <FormattedMessage {...messages.ownerBanner} />
                </h3>
              </div>
              <div className={s.imageCardBody}>
                <Image image={bannerImage} fieldName={"hostBannerImage1"} loader={hostBannerloader} />
              </div>
            </div>

            <div className={s.imageCard}>
              <div className={s.imageCardHeader}>
                <div className={s.imageCardHeaderIcon}>
                  <ImageIcon size={16} />
                </div>
                <h3 className={s.imageCardTitle}>
                  <FormattedMessage {...messages.imageLabel} />
                </h3>
              </div>
              <div className={s.imageCardBody}>
                <Image image={hostImage} fieldName={"hostBannerImage2"} loader={hostImageLoader} />
              </div>
            </div>
          </div>

          {/* Form Card */}
          <div className={s.formCard}>
            <div className={s.formCardHeader}>
              <div className={s.formCardHeaderIcon}>
                <Type size={18} />
              </div>
              <h3 className={s.formCardTitle}>Content Settings</h3>
            </div>
            <div className={s.formCardBody}>
              {/* Title */}
              <div className={s.formGroup}>
                <label className={s.formLabel}>
                  <FormattedMessage {...messages.hostBannerTitle} />
                </label>
                <MultiLanguageInput
                  baseField="hostBannerTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </div>

              {/* Main Content */}
              <div className={s.formGroup}>
                <label className={s.formLabel}>
                  <FormattedMessage {...messages.hostBannerContent} />
                </label>
                <MultiLanguageInput
                  baseField="hostBannerContent1"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </div>

              {/* Secondary Content */}
              <div className={s.formGroup}>
                <label className={s.formLabel}>
                  <FormattedMessage {...messages.contentLabel} />
                </label>
                <MultiLanguageInput
                  baseField="hostBannerContent2"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </div>

              {/* Buttons */}
              <div className={s.buttonsGrid}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>
                    <MousePointer size={14} style={{ marginRight: 6 }} />
                    <FormattedMessage {...messages.buttonLabel} /> 1
                  </label>
                  <MultiLanguageInput
                    baseField="buttonLabel"
                    inputType="text"
                    values={formValues}
                    onChange={this.handleFieldChange}
                  />
                </div>

                <div className={s.formGroup}>
                  <label className={s.formLabel}>
                    <MousePointer size={14} style={{ marginRight: 6 }} />
                    <FormattedMessage {...messages.buttonLabel} /> 2
                  </label>
                  <MultiLanguageInput
                    baseField="buttonLabel2"
                    inputType="text"
                    values={formValues}
                    onChange={this.handleFieldChange}
                  />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className={s.formCardFooter}>
              <button type="submit" className={s.saveButton} disabled={submitting}>
                {submitting ? <Loader2 size={18} className="spin" /> : <Save size={18} />}
                <FormattedMessage {...messages.save} />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }

}

WhyHostFormBlock1 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock1);

const selector = formValueSelector('WhyHostForm');

// Build formValues for multilingual fields
const textFields = ['hostBannerTitle1', 'hostBannerContent1', 'hostBannerContent2', 'buttonLabel', 'buttonLabel2'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  
  return {
    formValues,
    hostBannerloader: state.loader.hostBannerImage1,
    hostImageLoader: state.loader.hostBannerImage2,
    bannerImage: selector(state, 'hostBannerImage1'),
    hostImage: selector(state, 'hostBannerImage2'),
  };
};

const mapDispatch = {};

export default compose(
  withStyles(s),
  injectIntl,
  connect(mapState, mapDispatch)
)(WhyHostFormBlock1);